export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_1-dd46925f724a01e71630e4019d942735.mp4";